import { fontList } from './font';
import { CSSProperties } from 'styled-components';
import { DesignSettings } from '../interfaces';

const weightMap: Record<number, string> = {
    100: 'Thin',
    200: 'ExtraLight',
    300: 'Light',
    400: 'Regular',
    500: 'Medium',
    600: 'SemiBold',
    700: 'Bold',
    800: 'ExtraBold',
    900: 'Black',
};

export const getFontStyle = (
    designSettings: DesignSettings,
    type: 'primary' | 'secondary',
    weight: 'bold' | 'regular' = 'regular',
) => {
    const fontFamily = designSettings.fonts[type].fontFamily;
    const fontOption = fontList[fontFamily];
    if (!fontOption) return designSettings.fonts[type];

    const fontCss: CSSProperties = {
        ...designSettings.fonts[type],
        fontFamily: `${fontFamily}, ${fontOption.type}`,
    };
    if (type === 'primary') {
        fontCss.fontWeight = fontOption.primary[0];
    } else {
        fontCss.fontWeight = fontOption?.secondary?.[weight];
    }
    return fontCss;
};
export const fontsForWeb = (path: string, fontName: string): string => {
    const font = fontList[fontName];
    const css: string[] = [];
    const fontWeights = [];
    if (font?.primary) {
        fontWeights.push(...font.primary);
    }
    if (font?.secondary) {
        fontWeights.push(font.secondary.regular);
        fontWeights.push(font.secondary.bold);
    }
    fontWeights.forEach((weight) => {
        css.push(`
            @font-face {
              font-family: '${fontName}';
              font-weight: ${weight};
              font-style: normal;
              src: url('${path}/${fontName}/${fontName}-${weightMap[weight]}.woff2') format('woff2');
            }
        `);
    });
    return css.join('');
};
